import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COUNTRY_STATE, CountryState } from './country.state';

export const selectCountryState =
  createFeatureSelector<CountryState>(COUNTRY_STATE);

export const selectCountry = createSelector(
  selectCountryState,
  (state: CountryState) => {
    return state.data;
  }
);
